'use client';

import { ElementsPage } from "~pages_fsd/elements";

export default function ElementsRoutePage() {
  return <ElementsPage />;
}
